<header>
	<section class="view">
		<div class="login-container">
			<div class="login-form">
				Redirecting.......
			</div>
		</div>
	</section>
</header>